export default {
	state: {
		dadosContratacaoBeneficio: {}
	},
	getters: {
		"dadosContratacaoBeneficio": state => state.dadosContratacaoBeneficio
	},
	mutations: {
		setDadosContratacaoBeneficio(state, payload) {
			state.dadosContratacaoBeneficio = payload
		}
	},
	actions: {
		atualizarEstadoDadosContratacaoBeneficio({ commit }, payload) {
			commit('setDadosContratacaoBeneficio', payload)
		}
	}
};